import makeApi from 'app/services/api';

import { logError } from './logger';

export enum SuggestionStatus {
  NONE = 'none',
  SHOWN = 'shown',
  VISITED = 'visited',
  CLOSED = 'closed',
}

export default async function fetchSuggestedArticle({
  uuid,
  visitedArticleDescription,
  visitedArticleTitle,
}: {
  uuid?: string;
  visitedArticleDescription?: string;
  visitedArticleTitle?: string;
}) {
  const payload = {
    title: visitedArticleTitle,
    description: visitedArticleDescription,
  };
  const api = makeApi();
  let response;
  if (visitedArticleTitle && visitedArticleDescription) {
    response = await api.post(`/api/v1/web_chat/v3.0/help-center/${uuid}/knowledgebase/suggested-article/`, payload);
  } else {
    response = await api.get(`/api/v1/web_chat/v3.0/help-center/${uuid}/knowledgebase/suggested-article/`);
  }
  if (Object.keys(response.data).length === 0) {
    throw new Error('No suggested article found');
  }
  return response.data;
}

export async function postVisitedArticle({
  uuid,
  articleId,
  withSuggestedArticle = false,
}: {
  uuid: string;
  articleId: string;
  withSuggestedArticle: boolean;
}) {
  const api = makeApi();
  const payload = {
    kb_entry_id: articleId,
    get_suggested_article: withSuggestedArticle,
  };

  try {
    const response = await api.post(
      `/api/v1/web_chat/v3.0/help-center/${uuid}/knowledgebase/visited-article/`,
      payload
    );
    return response.data;
  } catch (error) {
    logError('Error posting visited article:', error);
    throw error;
  }
}

export async function patchSuggestedArticle({
  uuid,
  suggestionStatus,
}: {
  uuid: string;
  suggestionStatus: SuggestionStatus;
}) {
  const api = makeApi();
  const payload = {
    suggestion_status: suggestionStatus,
  };

  try {
    const response = await api.patch(
      `/api/v1/web_chat/v3.0/help-center/${uuid}/knowledgebase/suggested-article/`,
      payload
    );
    return response.data;
  } catch (error) {
    logError('Error patching suggested article:', error);
    throw error;
  }
}
